import React from 'react';

function Display({ value }) {
    return (
        <div className="Display">
            <span>
                {value}
            </span>
        </div>
    );
}

export default Display;
